import { render, staticRenderFns } from "./ComposicaoTransformacao.vue?vue&type=template&id=55b3ee40&"
import script from "./ComposicaoTransformacao.vue?vue&type=script&lang=js&"
export * from "./ComposicaoTransformacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports